import { SectionStyle } from '../../../helpers/SectionStyle';

export function getStyles(isPdf: boolean, params: any): any {
    isPdf = isPdf || false;
    params = params || {};
    // const backgroundColor: string = '#ed7d31';
    const backgroundColor: string = (SectionStyle.getSectionColors() || {}).datenauswertung; 
    const textIndent: number = 15;
    const { fontFamily, fontFamilyBold, fontSizeBig, fontSizeNorm, fontSizeSmall, colIndex, className } = params;
    const bold: React.CSSProperties = {
        ...(isPdf && { fontFamily: fontFamilyBold }),
        fontWeight: 'bold'
    };
    const cell: React.CSSProperties = {
        fontSize: fontSizeNorm,
        paddingTop: isPdf ? 4 : 6,
        paddingBottom: isPdf ? 3 : 4,
        borderTop: '1pt solid #fff',
        borderLeft: '1pt solid #fff',
        boxSizing: 'border-box',
        overflow: 'hidden'
    };
    const center: React.CSSProperties = {
        textAlign: 'center',
        paddingRight: 5,
        paddingLeft: 5
    };
    const left: React.CSSProperties = {
        textAlign: 'left',
        paddingLeft: 5
    };
    const right: React.CSSProperties = {
        textAlign: 'right',
        paddingRight: 5
    };
    const heading: React.CSSProperties = {
        ...cell, ...bold,
        fontSize: fontSizeBig,
        color: '#fff',
        backgroundColor,
        borderTop: 'none',
        justifyContent: 'center'
    };
    const heading2: React.CSSProperties = {
        ...heading,
        fontSize: fontSizeNorm
    };
    const sub: React.CSSProperties = {
        ...cell, ...bold,
        color: '#000',
        // backgroundColor: '#fce4d6'
        backgroundColor: '#c5ceb9'
    };
    const field: React.CSSProperties = {
        ...cell,
        color: '#000',
        backgroundColor: '#f7f7f7' //'#ddd'
    };
    const colSpan: any = className && colIndex >= 0 ? { colSpan: getColSpan(className, colIndex) } : {};

    return {
        row_field_vsme_heading: { ...heading, ...center, ...colSpan },
        row_field_vsme_heading_left: { ...heading, ...left },
        row_field_vsme_heading_right: { ...heading, ...right },
        row_field_vsme_heading2: { ...heading2, ...center },
        row_field_vsme_heading2_left: { ...heading2, ...left },
        row_field_vsme_heading2_right: { ...heading2, ...right },
        row_field_vsme_sub: { ...sub, ...center, ...colSpan },
        row_field_vsme_sub_left: { ...sub, ...left },
        row_field_vsme_sub_right: { ...sub, ...right },
        row_field_vsme_sub_span: { ...sub, ...center, flex: 1, ...colSpan },
        row_field_vsme: { ...field, ...center },
        row_field_vsme_left: { ...field, ...left, ...colSpan },
        row_field_vsme_right: { ...field, ...right, ...colSpan },
        row_field_vsme_bold: { ...field, ...bold, ...center },
        row_field_vsme_bold_left: { ...field, ...bold, ...left },
        row_field_vsme_bold_right: { ...field, ...bold, ...right, ...colSpan },
        row_field_vsme_indent_left: { ...field, ...left, paddingLeft: textIndent },
        row_field_vsme_cols_2_right: { ...field, ...right, cols: 2 },
        row_field_vsme_span: { ...field, ...center, flex: 1 },
        row_field_vsme_nobg_span: { ...field, ...center, backgroundColor: '#fff', whiteSpace: 'pre-wrap', flex: 1 },
        row_field_vsme_none: {
            ...field, color: '#fff', backgroundColor: '#fff', width: 0, paddingRight: 0, paddingLeft: 0, borderRight: 0, borderLeft: 0,
            flex: 0
        },
        row_field_vsme_jsx_none: {
            ...field, backgroundColor: '#fff', width: 0, maxHeight: 0, paddingRight: 0, paddingLeft: 0, borderRight: 0, borderLeft: 0,
            flex: 0, overflow: 'visible'
        },
        row_field_vsme_spacer: { ...field, color: '#fff', backgroundColor: '#fff' }
    }
}

function getColSpan(className: string, colIdx: number) {
    if (className !== 'row_field_vsme_cols_2_right' && colIdx > 1) {
        return 2;
    }
    if (className === 'row_field_vsme_sub_span' && colIdx === 0) {
        // return 8;
    }
    return 1;
}